import { useSelector } from 'react-redux';
import { Field } from 'formik';
import { Text } from '@/components/v4';
import NameField from '@/components/forms/new/formikFormFields/NameField';
import TrunkFieldRow from './TrunkFieldRow';

/**
 * Channel count. SRT trunks have no redundancy level, so this is the only
 * capacity input on the form.
 */
const SRTChannelsField = ({
    isInvalid,
    minChannels = 1,
    incSize = 1,
    maxChannels,
}) => {
    const { darkMode } = useSelector((state) => state.settings);

    return (
        <TrunkFieldRow
            label="Channels"
            tooltip="Number of concurrent calls this trunk can handle"
            ariaLabel="channels-tip"
            isInvalid={isInvalid}>
            <Field
                name="channels"
                component={NameField}
                darkMode={darkMode}
                placeholder="1"
            />
            <Text fontSize="xs" color="gray.500" mt={1}>
                {`Minimum channels is ${minChannels} in increments of ${incSize}`}
                {maxChannels > 0 && ` (max ${maxChannels})`}
            </Text>
        </TrunkFieldRow>
    );
};

export default SRTChannelsField;
